import { render, staticRenderFns } from "./class-composes.vue?vue&type=template&id=ed9db898&scoped=true"
import script from "./class-composes.vue?vue&type=script&lang=js"
export * from "./class-composes.vue?vue&type=script&lang=js"
import style0 from "./class-composes.vue?vue&type=style&index=0&id=ed9db898&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9db898",
  null
  
)

export default component.exports